import commonMsg from '@consigmais-team/vue-common/locale';


const  messages = {
   en: {
      appMsg: commonMsg.en,
      menu: {},
      caption: {}
   },
   pt: {
      appMsg: commonMsg.pt,
      menu: {},
      caption: {}
   }
};


/*

messages.en.menu.xyz = '';
messages.pt.menu.xyz = '';

*/





export default messages;


// WEBPACK FOOTER //
// ./src/locale/index.js